import React from "react";
import { useNavigate } from "react-router-dom";
import LandingBanner from "../components/Landing/landingBanner";
import LandingProcessingComparison from "../components/Landing/ProcessingComparison";
import HowItWorks from "../components/Landing/HowItWorks";
import EliminateProcessingFees from "../components/Landing/EliminateProcessingFees";
import MerchantMarvelsFAQ from "../components/FAQ";
import TestimonialsSection from "../components/TestimonialSection";
import ProductsGrid from "../components/ProductForm/products-grid";
import LandingHeader from "../components/Landing/landingHeader";
import LandingFooter from "../components/Landing/LandingFooter";
import LandingNewBanner from "../components/Landing/landingnewBanner";




function ProductsPage() {
  const navigate = useNavigate();
  return <ProductsGrid onStartApply={() => navigate("/apply")} />;
}

export default function Landing() {
  return (
    <>
      <LandingHeader />
      {/* <LandingBanner  
          leftImageSrc="/your-uploaded-left-image.png" 
          onCtaClick={() => { document.getElementById("products")?.scrollIntoView({ behavior: "smooth", }); }} 
      /> */}

       <LandingNewBanner />


      <LandingProcessingComparison />

      <HowItWorks 
      onCtaClick={() => { document.getElementById("products")?.scrollIntoView({ behavior: "smooth", }); }} 
      />

      <EliminateProcessingFees 
      onCtaClick={() => { document.getElementById("products")?.scrollIntoView({ behavior: "smooth", }); }} 
       />
       
      <TestimonialsSection />
      <ProductsPage />
      <MerchantMarvelsFAQ />
      <LandingFooter />
    </>
  );
}
